var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(240,240,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 43.141 44.662 v 7.903 h -2.549 V 33.021 h 6.628 c 1.614 0 3.144 0.595 4.334 1.699 c 1.19 1.02 1.784 2.549 1.784 4.164 s -0.595 3.059 -1.784 4.164 c -1.19 1.105 -2.634 1.699 -4.334 1.699 L 43.141 44.662 L 43.141 44.662 z M 43.141 35.4 v 6.798 h 4.249 c 0.935 0 1.869 -0.34 2.464 -1.02 c 1.36 -1.275 1.36 -3.399 0.085 -4.674 l -0.085 -0.085 c -0.68 -0.68 -1.53 -1.105 -2.464 -1.02 H 43.141 L 43.141 35.4 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(95,99,104)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 59.201 38.799 c 1.869 0 3.314 0.51 4.419 1.53 s 1.614 2.379 1.614 4.079 v 8.157 h -2.379 v -1.869 H 62.77 c -1.02 1.53 -2.464 2.294 -4.164 2.294 c -1.445 0 -2.719 -0.425 -3.739 -1.275 c -0.935 -0.85 -1.53 -2.039 -1.53 -3.314 c 0 -1.36 0.51 -2.464 1.53 -3.314 c 1.02 -0.85 2.464 -1.19 4.164 -1.19 c 1.53 0 2.719 0.255 3.654 0.85 v -0.595 c 0 -0.85 -0.34 -1.699 -1.02 -2.209 c -0.68 -0.595 -1.53 -0.935 -2.464 -0.935 c -1.445 0 -2.549 0.595 -3.314 1.784 l -2.209 -1.36 C 55.037 39.649 56.822 38.799 59.201 38.799 z M 55.972 48.486 c 0 0.68 0.34 1.275 0.85 1.614 c 0.595 0.425 1.275 0.68 1.954 0.68 c 1.02 0 2.039 -0.425 2.804 -1.19 c 0.85 -0.765 1.275 -1.699 1.275 -2.719 c -0.765 -0.595 -1.869 -0.935 -3.314 -0.935 c -1.02 0 -1.869 0.255 -2.549 0.765 C 56.312 47.127 55.972 47.721 55.972 48.486 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(95,99,104)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 79 39.224 l -8.412 19.289 h -2.549 l 3.144 -6.713 l -5.523 -12.491 h 2.719 l 3.994 9.602 h 0.085 l 3.909 -9.602 H 79 V 39.224 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(95,99,104)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.029 42.963 c 0 -0.765 -0.085 -1.53 -0.17 -2.294 H 22.238 v 4.334 h 6.033 c -0.255 1.36 -1.02 2.634 -2.209 3.399 v 2.804 h 3.654 C 31.84 49.251 33.029 46.362 33.029 42.963 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(66,133,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.238 53.924 c 3.059 0 5.608 -1.02 7.478 -2.719 l -3.654 -2.804 c -1.02 0.68 -2.294 1.105 -3.824 1.105 c -2.889 0 -5.438 -1.954 -6.288 -4.674 h -3.739 v 2.889 C 14.165 51.545 17.989 53.924 22.238 53.924 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(52,168,83)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.95 44.832 c -0.51 -1.36 -0.51 -2.889 0 -4.334 V 37.61 h -3.739 c -1.614 3.144 -1.614 6.883 0 10.112 L 15.95 44.832 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(251,188,4)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.238 35.91 c 1.614 0 3.144 0.595 4.334 1.699 l 0 0 l 3.229 -3.229 c -2.039 -1.869 -4.759 -2.974 -7.478 -2.889 c -4.249 0 -8.157 2.379 -10.027 6.203 l 3.739 2.889 C 16.799 37.865 19.349 35.91 22.238 35.91 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(234,67,53)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.68f1045e3cc18014c50d069ac67fefd6.svg";
export { ForwardRef as ReactComponent };